import React from 'react';

import {BreakpointExtended} from 'coreClasses/view/IViewportMgr';

export type Variant =
	'h1' |
	'h2' |
	'h3' |
	'h4' |
	'h5' |
	'h6' |
	'p' |
	'div' |
	'span' |
	'ol' |
	'li' |
	'ul'
;

export type VariantsMapping = {
	[key in Variant]: keyof React.JSX.IntrinsicElements;
};

export type FontSize = '10' | '12' | '14' | '16' | '18' | '24' | '28' | '36' | '56';
export type FontWeight = 'regular' | 'semi-bold';

type Operator = '<' | '<=' | '>' | '>=';

type Query = `${Operator}${BreakpointExtended}`;

type SizeCondition = {
	[key in Query]?: { fontSize: FontSize, fontWeight?: FontWeight } | FontSize
}

export interface ITypographyProps {
	variant?: Variant;
	children: React.ReactNode;
	classNames?: string;
	style?: React.CSSProperties;
	fontWeight?: FontWeight;
	fontSize?: FontSize;
	textCase?: 'reg' | 'upper' | 'cap' | 'none' | 'lower';
	sizes?: SizeCondition,
	onClick?: () => void;
}

/**
 * Guard function to check if the given value is a valid FontSize
 *
 * @param fontSize any value
 * @returns {boolean}
 */
export function isFontSize(fontSize: any): fontSize is FontSize {
	return typeof fontSize === 'string' && !isNaN(parseInt(fontSize));
}

